import { defineStore } from "pinia"
import { api, getAuthToken } from "@/boot/axios"
import type { AuthState, UserDetail, Interest } from "@/interfaces"
import router from '@/router'

export const useAuthStore = defineStore('authStore', {
  state: (): AuthState => ({
    user: null
  }),
  actions: {
    async userLogin(tgid: number) {
      await api.post(`/auth/token?tgid=${tgid}`)
        .then(async e => {
          const authToken = e.data.access
          localStorage.setItem('token', authToken)
          await this.getUserDetailData()
        })
        .catch(e => {
          if (e.response && e.response.status === 401) {
            console.error("Пользователь не найден")
            router.push('/application')
          }
        })
    },
    async getUserDetailData() {
      const authToken = localStorage.getItem('token')
      if (authToken) {
        try {
          const response = await api.get<UserDetail>('/auth/me/detail', {
            headers: {
              Authorization: getAuthToken()
            }
          })

          this.user = response.data

          if (response.data.userTariff.status === 'Приостановлен'){
            router.push('/application')
          }

          if (!this.user.onboarding) router.push('/onboarding')
        } catch (error) {
          console.error("Ошибка при получении детальных данных пользователя:", error)
          this.user = null
        }
      }
    },
    clearUserData() {
      this.user = null
      localStorage.removeItem('token')
    },
    closeOnboarding: async function() {
      await api.get('/user/close-onboarding', {
        headers: {
          'Authorization': getAuthToken()
        }
      })

      if (this.user) this.user.onboarding = true

      router.push('/')
    }
  },
  getters: {
    userInterests(): Interest[] {
      if (!this.user || !this.user.interest) return []
      return this.user.interest.map(userInterest => userInterest.interest)
    },
    userInterestNames(): string[] {
      return this.userInterests.map(interest => interest.name)
    }
  }
})